import { NgModule } from '@angular/core';
import {
  ExtraOptions,
  PreloadAllModules,
  RouterModule,
  Routes
} from '@angular/router';
import { UserResolverService } from './global/services/user-resolver.service';
import { SignUpGuard } from './global/guards/sign-up-guard.service';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.module').then(auth => auth.AuthModule),
    canActivate: [SignUpGuard]
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./features/pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'feature-list',
    loadChildren: () =>
      import('./features/feature-list/feature-list.module').then(
        m => m.FeatureListModule
      )
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then(m => m.AboutModule)
  },
  // {
  //   path: 'settings',
  //   loadChildren: () =>
  //     import('./features/settings/settings.module').then(m => m.SettingsModule)
  // },
  // {
  //   path: 'examples',
  //   loadChildren: () =>
  //     import('./features/examples/examples.module').then(m => m.ExamplesModule)
  // },
  {
    path: '',
    loadChildren: () =>
      import('./home/home.module').then(home => home.HomeModule),
    resolve: { UserResolverService }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  // useHash supports github.io demo page, remove in your app
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
